import { useEffect } from 'react';
import { SerializedError } from '@reduxjs/toolkit';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { useQueryClientName } from './clientHook';
import { replace, push, useRouteMatch } from '../../app/route';
import {
  getClientListUrl,
  getClientDetailUrl,
  UpdateClientActionResponse,
} from './clientSlice';
import {
  selectCurrentTenantId,
} from '../user/userSlice';
import { ClientCreateForm } from './ClientCreateForm';
import { ClientEditForm } from './ClientEditForm';
import { ClientView } from './ClientView';

type PathParams = {
  mode: 'view'|'edit'|'create';
  tenant_id: string;
};

export function ClientPage() {
  const dispatch = useAppDispatch();
  const match = useRouteMatch<PathParams>();
  const { mode } = match.params;
  const client_name = useQueryClientName();
  const tenant_id = useAppSelector(selectCurrentTenantId);

  useEffect(() => {
    if (['view', 'edit'].includes(mode) && !client_name) {
      dispatch(replace(getClientListUrl(tenant_id)));
    }
  }, [dispatch, client_name, mode, tenant_id]);
  useEffect(() => {
    if (tenant_id !== match.params.tenant_id) {
      dispatch(push(getClientListUrl(tenant_id)));
    }
  }, [tenant_id, dispatch, match.params.tenant_id]);

  const handleCreateCallback = (client_name: string) => {
    dispatch(push(getClientDetailUrl(tenant_id, client_name, 'view')));
  };
  const handleUpdateCallback = (result: UpdateClientActionResponse) => {
    dispatch(push(getClientDetailUrl(tenant_id, client_name, 'view')));
  };
  const handleDismissCallback = (error?: SerializedError) => {
    if (error) {
      dispatch(push(getClientListUrl(tenant_id)));
    } else if (mode === 'create') {
      dispatch(push(getClientListUrl(tenant_id)));
    } else if (mode === 'edit' || mode === 'view') {
      dispatch(push(getClientDetailUrl(tenant_id, client_name, 'view')));
    }
  };
  const handleGoBack = () => {
    dispatch(push(getClientListUrl(tenant_id)));
  };
  const handleEdit = () => {
      dispatch(push(getClientDetailUrl(tenant_id, client_name, 'edit')));
  };
  return (
    <div className="container">
      <div className="d-flex justify-content-between py-4">
        { mode === 'create' && <h1>Create Client</h1> }
        { mode === 'edit' && <h1>Edit Client</h1> }
        { mode === 'view' && <h1>View Client</h1> }
        { mode === 'view' && (
          <div className="btn-group" role="group">
            <button className="btn btn-outline-primary my-2" onClick={handleGoBack}>
              GoBack
            </button>
            <button className="btn btn-outline-primary my-2" onClick={handleEdit}>
              Edit
            </button>
          </div>
        )}
      </div>
      { mode === 'create' && 
        <ClientCreateForm
          tenant_id={tenant_id}
          successCallback={handleCreateCallback}
          dismissCallback={handleDismissCallback}
        />
      }
      { mode === 'edit' && 
        <ClientEditForm
          tenant_id={tenant_id}
          client_name={client_name}
          successCallback={handleUpdateCallback}
          dismissCallback={handleDismissCallback}
        />
      }
      { mode === 'view' &&
        <ClientView
          tenant_id={tenant_id}
          client_name={client_name}
          closeCallback={handleDismissCallback}
        />
      }
    </div>
  );
}
